import { createStore } from '@stencil/store';

import { initialState } from './store.minimal-certificate';

const { on, onChange, state, reset } = createStore({ ...initialState, isKelleyBuysYourCar: true });

export { initialState, on, onChange, state, reset };
